export default __webpack_public_path__ + "static/media/IMG_2189.accb8544.jpg";